module.exports = __webpack_public_path__ + "img/ava-2.2097cbac.png";